import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchDeleteEthicsTeamGroup } from "./helpAndAssistantApi";
import swal from 'sweetalert';
export interface DeleteEthicsTeamGroupState {
  deleteEthicsTeamGroup: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: DeleteEthicsTeamGroupState = {
  deleteEthicsTeamGroup: [],
  status: "idle",
};

export const GetDeleteEthicsTeamGroup = createAsyncThunk(
  "DeleteEthicsTeamGroup",
  async (data: any) => {
    const response = await fetchDeleteEthicsTeamGroup(data);
    return response;
  }
);

export const DeleteEthicsTeamGroupSlice = createSlice({
  name: "DeleteEthicsTeamGroup",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetDeleteEthicsTeamGroup.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetDeleteEthicsTeamGroup.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetDeleteEthicsTeamGroup.fulfilled, (state, action) => {
        state.status = "success";
        state.deleteEthicsTeamGroup = action.payload;
        //swal("Record saved success!",  "success");
      });
  },
});

export const {} = DeleteEthicsTeamGroupSlice.actions;

export const selectDeleteEthicsTeamGroup = (state: RootState) => {
  return state.DeleteEthicsTeamGroup.deleteEthicsTeamGroup;
};

export default DeleteEthicsTeamGroupSlice.reducer;
